import { render, staticRenderFns } from "./DDClients.vue?vue&type=template&id=4ef51c26&"
import script from "./DDClients.vue?vue&type=script&lang=js&"
export * from "./DDClients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports